import {
  BaseRecord,
  HttpError,
  IResourceComponentsProps,
} from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import { Textarea, TextInput } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { UpdateSalesAnnouncement } from "entities/sale_announcement";

export const SaleAnnouncementEdit: React.FC<IResourceComponentsProps> = () => {
  const { getInputProps, saveButtonProps } = useForm<
    BaseRecord,
    HttpError,
    UpdateSalesAnnouncement
  >({
    refineCoreProps: {
      redirect: "show",
    },
    initialValues: {
      title: "",
      url: "",
      activated_at: new Date(),
    },
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <TextInput label="Title" {...getInputProps("title")} />
      <Textarea label="URL" {...getInputProps("url")} />
      <DatePicker
        placeholder="Pick dates range"
        maw={400}
        label="Activated at"
        defaultValue={new Date()}
        withinPortal
        {...getInputProps("activated_at")}
      />
    </Edit>
  );
};
